import request from '@/utils/request'

// 强制终止
export function apiScpMrpPlansAbortPlan (data) {
  return request({
    url: '/scp/scpMrpPlans/abortPlan',
    method: 'post',
    data: data
  })
}

// 启动
export function apiScpMrpPlansStartPlan (data) {
  return request({
    url: '/scp/scpMrpPlans/startPlan',
    method: 'post',
    data: data
  })
}

// 修改
export function apiScpMrpPlanStages (data) {
  return request({
    url: '/scp/scpMrpPlanStages',
    method: 'put',
    data: data
  })
}

// 弹窗-修改
export function apiScpMrpPlanStagesDetail (data) {
  return request({
    url: '/scp/scpMrpPlanStagesDetail',
    method: 'put',
    data: data
  })
}

// 运行
export function apiScpMasterControlMasterControl (query) {
  return request({
    url: '/scp/scpMasterControl/masterControl',
    method: 'get',
    params: query
  })
}

// 日志详情
export function apiScpMrpPlanLogsDetails (query) {
  return request({
    url: '/scp/scpMrpPlanLogs/details',
    method: 'get',
    params: query
  })
}

// 日志列表
export function apiScpMrpPlanStagesPlanRunFrame (query) {
  return request({
    url: '/scp/scpMrpPlanStages/planRunFrame',
    method: 'get',
    params: query
  })
}

// 获取计划版本
export function apiScpMrpPlansLatestVersion (query) {
  return request({
    url: '/scp/scpMrpPlans/latestVersion',
    method: 'get',
    params: query
  })
}

// 启动按钮--判断
export function apiScpMrpPlansSamePlannedTask (planName) {
  return request({
    url: `/scp/scpMrpPlans/samePlannedTask/${planName}`,
    method: 'get'
  })
}
